const mEditionAcademyConfigurationModalEdit = {
  mEditionAcademyConfigurationModalEdit: {
    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ACEPTO',

    message: {
      first: 'Al editar la url de tu academia se modificará el acceso a todos los alumnos, deberás enviar el enlace a los alumnos ya inscriptos nuevamente.',
      second: '¿Aceptas este cambio?'
    },

    title: 'Atención'
  }
}

export default mEditionAcademyConfigurationModalEdit
